import { render, staticRenderFns } from "./ConvertPpsToGh.vue?vue&type=template&id=1b1921ba&"
import script from "./ConvertPpsToGh.vue?vue&type=script&lang=js&"
export * from "./ConvertPpsToGh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports